<template>
  <div class="modal-dialog">
    <div class="modal-content success-pop-up">
      <div class="modal-body">
        <button type="button" class="close resource-close" data-dismiss="modal" @click="closeModal()">
          &times;
        </button>
        <div class="row">
          <div class="col-12 col-sm-12 col-md-12 material-name">
            <span v-if="materialFileName.title">{{ materialFileName.title }} </span>
          </div>
          <div class="col-12 col-sm-12 col-md-12">
            <img v-if="getFileType(materialFileName.fileType) == 'image'" class="file-size" :src="materialFile" />
            <object v-else-if="getFileType(materialFileName.fileType) == 'pdf'" :data="materialFile" type="application/pdf" class="file-size"></object>
            <object v-else-if="getFileType(materialFileName.fileType) == 'xlsx'" :data="materialFile" class="file-size"></object>
            <iframe v-else-if="getFileType(materialFileName.fileType) == 'docx'" :src="materialFile" class="file-size"></iframe>
            <video v-else-if="getFileType(materialFileName.fileType) == 'mp4'" class="file-size" controls :src="materialFile"></video>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ShowmaterialFilePopup",
  props: ["materialData"],
  data() {
    return {
      materialFile: "",
      studyId: this.$route.params.studyId,
      getfilePath: "",
      materialFileName: ""
    };
  },
  methods: {
    getFileType(filetype) {
      if (filetype) {
        if (filetype.includes("image")) {
          return "image";
        } else if (filetype.includes("pdf")) {
          return "pdf";
        } else if (filetype.includes("wordprocessingml.document")) {
          return "docx";
        } else if (filetype.includes("spreadsheetml.sheet")) {
          return "xlsx";
        } else if (filetype.includes("mp4")) {
          return "mp4";
        }
        return "none";
      } else {
        return "none";
      }
    },
    closeModal() {
      this.materialFile = "";
    },
    async getMaterialFiledata() {
      const materialfile = {
        studyId: this.studyId,
        filePath: this.materialFileName.filePath
      };
      await this.$api.getPresignedURL(materialfile).then(response => {
        if (response) {
          this.materialFile = response.body.preSignedUrl;
          if (this.getFileType(this.materialFileName.fileType) == "xlsx") {
            window.open(response.body.preSignedUrl);
          }
        }
      });
    }
  },
  created() {
    this.$root.$on("showMaterialFile", data => {
      this.materialFileName = data;
      this.getMaterialFiledata();
    });
  }
};
</script>

<style lang="scss" scoped>
.success-pop-up {
  width: 700px;
  ///  height: 450px;
  margin: 0px 0 3.1px -82px;
  // padding: 114px 8px 12.3px 6px;
  border-radius: 4px;
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.25);
  background-color: #ffffff;
}
.document-size {
  height: 340px;
  width: 445px;
}
.material-name {
  font-size: 20px;
  font-weight: bold;
  position: relative;
  text-align: left;
  color: #666669;
  font-family: "RobotoRegular";
}
.pdf-style {
  width: 453px;
  height: 334px;
}
.file-size {
  width: 636px;
  height: 356px;
  margin: 12px 0px 0px 0px;
}
button.resource-close {
  position: relative;
  left: 3px;
  bottom: 10px;
  font-size: 30px;
}
.success-message {
  font-size: 16px;
  font-weight: bold;
  padding: 26px;
  text-align: center;
  color: #666669;
  font-family: "RobotoRegular";
}
.button-position {
  text-align: center;
}
.btn-cancel-option {
  color: #959fa4;
  width: 90px;
  font-size: 14px;
  font-family: "RobotoRegular";
}
.btn-yes-option {
  background-color: #dc3545;
  color: #fff;
  width: 90px;
  font-size: 14px;
  font-family: "RobotoRegular";
}
</style>
